export type IteroBoxAction =
    'browse' | 'test' | 'connect' | 'chooseClinic' | 'changeClinic' | 'refresh' | 'disconnect';

export interface IteroBoxAccess {
    canView: boolean;
    canManage: boolean;
}

export interface IteroBoxState {
    /** Null until the status loads, and always null without view access. */
    connected: boolean | null;
    clinicId: number | null;
}

export function isIteroBoxVisible(access: IteroBoxAccess): boolean {
    return access.canView || access.canManage;
}

export function shouldLoadIteroStatus(access: IteroBoxAccess): boolean {
    return access.canView;
}

// Without view access the status (and so the connection state) is unknowable, so manage-only
// users get every manage action and the server decides what applies.
export function iteroBoxActions(access: IteroBoxAccess, state: IteroBoxState): IteroBoxAction[] {
    if (!access.canView) {
        return access.canManage ? ['chooseClinic', 'refresh', 'disconnect'] : [];
    }
    if (state.connected === null) return [];
    if (!state.connected) return access.canManage ? ['connect'] : [];
    const viewActions: IteroBoxAction[] = state.clinicId === null ? ['test'] : ['browse', 'test'];
    const manageActions: IteroBoxAction[] = access.canManage
        ? ['refresh', 'changeClinic', 'disconnect']
        : [];
    return [...viewActions, ...manageActions];
}

export interface BrowseRouteGate {
    hasParams: boolean;
    isRouteOpen: boolean;
    canView: boolean;
    // The status loaded, so canBrowse is the final answer rather than "not yet known".
    isStatusKnown: boolean;
    canBrowse: boolean;
}

// A failed status load keeps the params, so the box's Retry can still open the linked view.
export function shouldDropBrowseParams(gate: BrowseRouteGate): boolean {
    if (!gate.hasParams) return false;
    if (!gate.isRouteOpen || !gate.canView) return true;
    return gate.isStatusKnown && !gate.canBrowse;
}
